import { useState, useCallback } from 'react';
import { FaInfoCircle, FaExclamationTriangle, FaExclamationCircle } from "react-icons/fa";

/**
 * Custom hook for managing modal-specific alerts
 * Provides the same interface as useAlert but for modal contexts
 */
export const useModalAlert = () => {
    const [modalAlert, setModalAlert] = useState(null);

    const setInfoAlert = useCallback((message) => {
        setModalAlert({
            type: 'info',
            icon: <FaInfoCircle />,
            message
        });
    }, []);

    const setAlert = useCallback((message) => {
        setModalAlert({
            type: 'warning',
            icon: <FaExclamationTriangle />,
            message
        });
    }, []);

    const setErrorAlert = useCallback((message) => {
        setModalAlert({
            type: 'error',
            icon: <FaExclamationCircle />,
            message
        });
    }, []);

    const clearAlert = useCallback(() => {
        setModalAlert(null);
    }, []);

    return {
        modalAlert,
        setInfoAlert,
        setAlert,
        setErrorAlert,
        clearAlert
    };
};